import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RazorpayDto } from 'src/app/models/razorpay.model';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ToastNotificationService } from 'src/app/shared/services/toast-notify.service';
import { Router } from '@angular/router';
import { TokenStorageService } from 'src/app/shared/services/token-storage.service';

//declare var Razorpay: any;

@Injectable({ providedIn: 'root' })
export class RazorpayService {
  constructor(private http: HttpClient,private toastNotifyService: ToastNotificationService,
    private router: Router,private tokenStorageService: TokenStorageService,) {}

  createSalesOrder(razorpayDto: RazorpayDto): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/inventory/payment/createOrder',razorpayDto);
  }
  verifySalesPayment(payload: any): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/inventory/payment/verifyPayment',payload);
  }
  createFeeOrder(razorpayDto: RazorpayDto): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/payment/createOrder',razorpayDto);
  }
  verifyFeePayment(payload: any): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/payment/verifyPayment',payload);
  }

  paySalesWithRazor(razorOrder: any, invOrder: any) {
    const options = {
      key: razorOrder.keyId,
      amount: razorOrder.amount,
      currency: razorOrder.currency,
      name: 'Campusnex',
      description: 'Test Transaction',
      order_id: razorOrder.orderId, // razorpay orderid
      handler: (razorPayResponse: any) => {
        console.log('>>>>>>> Response from razorpay',JSON.stringify(razorPayResponse));
        /*this.http.post('/api/payment/verify', response).subscribe(result => {
        console.log('Verification result:', result);
        });*/
        const payload = {
          orderId: razorPayResponse.razorpay_order_id,
          paymentId: razorPayResponse.razorpay_payment_id,
          signature: razorPayResponse.razorpay_signature,
          orderIdInventory: invOrder.id,
          amount:invOrder.totalAmount,
        };

        this.verifySalesPayment(payload).subscribe(
          res => {        
            console.log('paymentOrder res>>>>>> ',JSON.stringify(res)) 
            if(environment.SUCCESS == res.status){
              this.toastNotifyService.showSuccess(res.message, "Notification");

              let userRole = this.tokenStorageService.getUserRole();
              let contextPath = this.tokenStorageService.roleContextMap.get(userRole);
              this.router.navigate(['/'+contextPath+'/inventory/saleItem']);
              //this.router.navigate(['/admin/inventory/saleItem']); // works fine
            }else if(environment.FAILURE == res.status){
              this.toastNotifyService.showErrorWithTimeout(res.message, "Notification", 7000);
            }        
          },
          error => {
            console.log('!!! Error in  verify payment:',error);  
            this.toastNotifyService.showErrorWithTimeout('Error in payment verification', "Notification", 7000);  
          },
        );
      },
      prefill: {
        name: 'Nishan',
        email: 'test@example.com',
        contact: '9999999999',
      },
      theme: { color: '#3399cc' },
    };

    const rzp = new (window as any).Razorpay(options);
    const razorPayRespOpen = rzp.open();
  }
  payFeeWithRazor(razorOrder: any, studentFeeId: number) {
    const options = {
      key: razorOrder.keyId,
      amount: razorOrder.amount,
      currency: razorOrder.currency,
      name: 'Campusnex',
      description: 'Test Transaction',
      order_id: razorOrder.orderId, // razorpay orderid
      handler: (razorPayResponse: any) => {
        console.log('>>>>>>> Response from razorpay',JSON.stringify(razorPayResponse));
        /*this.http.post('/api/payment/verify', response).subscribe(result => {
        console.log('Verification result:', result);
        });*/
        const payload = {
          orderId: razorPayResponse.razorpay_order_id,
          paymentId: razorPayResponse.razorpay_payment_id,
          signature: razorPayResponse.razorpay_signature,
          feeId: studentFeeId,
          amount:razorOrder.amount,
        };

        this.verifyFeePayment(payload).subscribe(
          res => {        
            console.log('paymentOrder res>>>>>> ',JSON.stringify(res)) 
            if(environment.SUCCESS == res.status){
              this.toastNotifyService.showSuccess(res.message, "Notification");
              /*let userRole = this.tokenStorageService.getUserRole();
              let contextPath = this.tokenStorageService.roleContextMap.get(userRole);
              this.router.navigate(['/'+contextPath+'/inventory/saleItem']);*/
            }else if(environment.FAILURE == res.status){
              this.toastNotifyService.showErrorWithTimeout(res.message, "Notification", 7000);
            }        
          },
          error => {
            console.log('!!! Error in  verify payment:',error);  
            this.toastNotifyService.showErrorWithTimeout('Error in payment verification', "Notification", 7000);  
          },
        );
      },
      prefill: {
        name: 'Nishan',
        email: 'test@example.com',
        contact: '9999999999',
      },
      theme: { color: '#3399cc' },
    };

    const rzp = new (window as any).Razorpay(options);
    const razorPayRespOpen = rzp.open();
  }
}